module.exports = __webpack_public_path__ + "img/tax03.0ca7f5b4.png";